var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "ugc-history control"
  }, [_c('div', {
    staticClass: "ugc-history-wrapper text-center"
  }, [_c('button', {
    staticClass: "ugc-history-wrapper-undo",
    attrs: {
      "disabled": _vm.isUndoDisabled
    },
    on: {
      "click": _vm.undo
    }
  }, [_c('div', {
    staticClass: "text-icon"
  }, [_vm._v(_vm._s(_vm.translations.ugcHistoryUndo))]), _vm.$store.state.utils.configuration.enableNewUgcModal ? _c('customs-svg-icon', {
    attrs: {
      "src": "".concat(_vm.customsAssets, "/svg/customizer/icon-undo.svg")
    }
  }) : _c('span', {
    staticClass: "icon icon-undo"
  })], 1), _c('button', {
    staticClass: "ugc-history-wrapper-redo",
    attrs: {
      "disabled": _vm.isRedoDisabled
    },
    on: {
      "click": _vm.redo
    }
  }, [_c('div', {
    staticClass: "text-icon"
  }, [_vm._v(_vm._s(_vm.translations.ugcHistoryRedo))]), _vm.$store.state.utils.configuration.enableNewUgcModal ? _c('customs-svg-icon', {
    attrs: {
      "src": "".concat(_vm.customsAssets, "/svg/customizer/icon-redo.svg")
    }
  }) : _c('span', {
    staticClass: "icon icon-redo"
  })], 1)]), _c('div', {
    staticClass: "ugc-history-instructions text-center"
  }, [_vm._v("\n    " + _vm._s(_vm.translations.ugcHistoryInstructions) + "\n  ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }